import {ThreeElements} from '@react-three/fiber';
import {LatLong, NamedCluster, StoreData, StoreDataWithCluster, storeLocations} from "src/stores/storeLocations";
import {Group, Vector3} from "three";


interface FreshStoresProps {
    onStoreClick: (storeId: StoreData) => void;
}

function latLongToVector3(latLong: LatLong): Vector3 {
    const latRads = latLong.lat * Math.PI / 180;
    const lngRads = latLong.lng * Math.PI / 180;

    const r = 100;
    const z = Math.cos(lngRads) * Math.cos(latRads) * r;
    const x = Math.sin(lngRads) * Math.cos(latRads) * r;
    const y = Math.sin(latRads) * r;

    return new Vector3(x, y, z);
}

function FreshStores(props: FreshStoresProps & ThreeElements['group']) {

  return (
    <group {...props}>
        <group>
        {Object.entries(storeLocations.stores).map(([storeId, storeData]) => {

            // const mercatorK = 1 / Math.cos(latLong.lat * Math.PI / 180);
            // console.log(mercatorK)

            // const x = latLong.lng * 0.158646 + 15.6113;
            // const y = latLong.lat * 0.236559 - 8.59185;
            // const z = .15;

            const vec = latLongToVector3(storeData);

            return <StoreBlock storeData={storeData} position={vec} onStoreClick={props.onStoreClick} />
        })}
        </group>
        <group>
            {storeLocations.clusters.map((cluster, index) => {
                const vec = latLongToVector3(cluster.centroid);
                return <ClusterBlock cluster={cluster} position={vec} />
            })}
        </group>
    </group>
  )
}

interface StoreBlockProps {
    storeData: StoreDataWithCluster;
    onStoreClick: (storeData: StoreData) => void;
}

export const storeWorldPositions: Record<string, Vector3> = {};
export const clusterWorldPositions: Record<string, Vector3> = {};

interface ClusterBlockProps {
    cluster: NamedCluster;
}

function ClusterBlock(props: ClusterBlockProps & ThreeElements['group']) {
    const cluster = props.cluster;

    const setClusterLocationRef = (group: Group) => {
        if (group) {
            clusterWorldPositions[cluster.name] = group.localToWorld(new Vector3(0, 0, 0));
        }

    }

    return (
        <group {...props} ref={setClusterLocationRef}>
            <mesh visible={false}>
                <boxGeometry args={[1, 1, 1]} />
                <meshStandardMaterial color="#FFFF00"/>
            </mesh>
        </group>

    )
}

function StoreBlock(props: StoreBlockProps & ThreeElements['group']) {

    const setStoreGroupRef = (group: Group) => {
        if (group) {
            storeWorldPositions[props.storeData.storeId] = group.localToWorld(new Vector3(0, 0, 0))
        }
    }

    const colors = [
        "#FF0000",
        "#00FF00",
        "#0000FF",
        "#00ffe1",
        "#ffa600",
        "#c800ff",
        "#ffffff",
        "#858585",
        "#007826",
        "#780000",
        "#ff9f9f",
        "#000000",
        "#5e3200",
    ];

    const clusterName = props.storeData.cluster.name;
    const clusterIndex = storeLocations.clusters.findIndex((c) => c.name === clusterName);

    return (
      <group {...props} ref={setStoreGroupRef} onClick={() => props.onStoreClick(props.storeData)}>
          <mesh visible={false}>
              <boxGeometry args={[0.5, 0.5, 0.5]}/>
              <meshStandardMaterial color={colors[clusterIndex % colors.length]} />
          </mesh>
      </group>
  );
}


export default FreshStores;
